import React, { type FC } from 'react';

import type { DropdownOption } from 'src/common/components/DropdownDS22';
import type { ImmutableTrip } from 'src/types/trips/Trips';
import type { Location } from 'history';
import { MOVED_PAGES, PATHS } from '../../../../common/constants';
import { preserveSearch } from '../../../../common/utils/routing';
import { userIsRenter } from '../../../helpers';
import {
  CaptainCard,
  CommentCard,
  DatesCard,
  DurationCard,
  GroupSizeCard,
  TimeCard,
  VesselCard,
} from '../../cards';
import ArchiveButton from '../../ArchiveButton';
import TripMenu from '../../TripMenu';
import TripPanel from '../../presentation/TripPanel';
import content, { getMessage } from '../content';
import CTA, { CTALink } from '../../CTA';
import TripDetailsTitle from '../../presentation/TripDetailsTitle';

type LapsedProps = {
  cancellationDropdownOptions: DropdownOption[];
  trip: ImmutableTrip;
  location: Location;
};

const Lapsed: FC<LapsedProps> = ({
  cancellationDropdownOptions,
  trip,
  location,
}) => {
  const tripState = trip.getIn(['state', 'state']);
  const isRenter = userIsRenter(trip);
  const archived = trip.get('archived');
  const cta = (
    <CTA classNameModifier="withSidebar">
      {isRenter ? (
        <>
          <TripMenu
            cancellationDropdownOptions={cancellationDropdownOptions}
            trip={trip}
          />
          <CTALink
            to={`${MOVED_PAGES.LISTING}${trip.getIn(['boat', 'id'])}/?sheet=true`}
          >
            Send a new inquiry
          </CTALink>
        </>
      ) : (
        <ArchiveButton
          archived={archived}
          trip={trip}
        >
          {`${archived ? 'Unarchive' : 'Archive'} this Inquiry`}
        </ArchiveButton>
      )}
    </CTA>
  );

  return (
    <TripPanel
      trip={trip}
      subheader={content.title[tripState]}
      intro={getMessage(trip, location)}
      cta={cta}
      backLocation={preserveSearch(PATHS.INBOX, location)}
      classNameModifier="withoutSideMargins"
    >
      <TripDetailsTitle />
      <VesselCard
        readOnly
        trip={trip}
      />
      <DatesCard
        readOnly
        trip={trip}
      />
      <TimeCard
        readOnly
        trip={trip}
      />
      <DurationCard
        trip={trip}
      />
      <GroupSizeCard
        readOnly
        trip={trip}
      />
      <CaptainCard
        readOnly
        trip={trip}
      />
      <CommentCard
        readOnly
        trip={trip}
      />
    </TripPanel>
  );
};

export default Lapsed;
